import { z } from 'zod'

/** Sender-visible, account-scoped remote attention. Local drafts never enter this API. */
export const AttentionReason = z.enum([
  'PENDING_FINALIZATION',
  'DELIVERY_FAILURE',
  'SIGNING_EXPIRING',
  'SENDER_SIGNATURE_REQUIRED',
  /** A manual step that is the signer's turn and whose link was never revealed to the sender. */
  'NEXT_LINK_READY',
  /** A signer declined; shown for a few days so the sender sees why and can send a new request. */
  'REQUEST_DECLINED',
  'UNFINISHED_DRAFT',
])
export type AttentionReason = z.infer<typeof AttentionReason>

export const RemoteAttentionQuery = z
  .object({ limit: z.coerce.number().int().min(1).max(100).optional() })
  .strict()
export type RemoteAttentionQuery = z.infer<typeof RemoteAttentionQuery>

export const RemoteAttentionItem = z
  .object({
    agreement_id: z.string().min(1).max(128),
    envelope_id: z.string().min(1).max(128),
    title: z.string().min(1).max(300),
    reason: AttentionReason.exclude(['UNFINISHED_DRAFT']),
    relevant_deadline: z.string().datetime().nullable(),
    updated_at: z.string().datetime(),
  })
  .strict()
export type RemoteAttentionItem = z.infer<typeof RemoteAttentionItem>

export const RemoteAttentionResponse = z
  .object({
    items: z.array(RemoteAttentionItem),
    total: z.number().int().nonnegative(),
  })
  .strict()
export type RemoteAttentionResponse = z.infer<typeof RemoteAttentionResponse>
